import { mesaColorNames } from '@/src/common/theme'
import { Redirect, Stack, usePathname } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useIsTabBarPositionedTop, topTabBarHeight } from '@/src/common/components/TopTabBar'
import { useTransactionEventDetailsCardStackScreenProps } from '@/src/app/main/(tabs)/card/card-management/transaction-event/[id]'
import { usePaymentCardStackScreenProps } from '@/src/experiences/card-payments/screens/MakePayment'
import { useAccountsScreenProps } from '@/src/app/main/(tabs)/card/card-management/accounts'
import {
  useCardManagementStackScreensAreModals,
  useCardStackScreen,
} from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { Loading } from '@/src/common/components/Loading'

// eslint-disable-next-line
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default withCardGate(function CardManagementLayout({
  applicationStatusInitialized,
  showCardManagement,
}) {
  const path = usePathname()
  const isCardManagementIndex = path === Routes.CardManagement.route
  const isTabBarPositionedTop = useIsTabBarPositionedTop()

  if (!applicationStatusInitialized) {
    return <Loading />
  }

  if (!showCardManagement) {
    return <Redirect href="/main/card" />
  }

  return (
    <SafeAreaView
      style={{
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: isCardManagementIndex
          ? mesaColorNames['Mesa - Brand/White #FFFFFF']
          : mesaColorNames['Mesa - Brand/Secondary #223843'],
        paddingTop: isTabBarPositionedTop ? topTabBarHeight : 0,
      }}
      edges={{
        top: 'additive',
        left: 'additive',
        bottom: 'off', // Fix for SafeAreaView not expanding full screen on iOS
        right: 'additive',
      }}
    >
      <LayoutNav />
    </SafeAreaView>
  )
})

function LayoutNav() {
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="virtual-card" options={{ headerShown: false }} />
      {useTransactionEventDetailsCardStackScreenProps().screen()}
      {usePaymentCardStackScreenProps().screen()}
      {useAccountsScreenProps().screen()}
      {useCardStackScreen({
        name: 'statements',
        options: {
          title: 'Statements',
          presentation: cardManagementStackScreensAreModals ? 'transparentModal' : 'modal',
          headerShown: false,
        },
      }).screen()}
    </Stack>
  )
}
